const t = {
  name: "SquareStraight",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 2H22V22H2V2ZM4 4V20H20V4H4Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as SquareStraight
};
